<template>
    <div
        class="map-info-container"
        @click.stop="$emit('click')"
    >
        <table
            class="w-100"
            style="background: transparent !important"
        >
            <caption
                v-if="title"
                class="map-title"
            >
                {{ title }}
            </caption>
            <thead>
                <tr style="background: transparent !important;">
                    <th
                        v-for="field in fields"
                        :key="field.key"
                        style="color: #BEFF41 !important; font-size: .9em; font-weight: bold; padding: .2em .5em; text-transform: uppercase"
                    >
                        {{ field.label || field.key }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(item, index) in data"
                    :key="index"
                >
                    <td
                        v-for="field in fields"
                        :key="field.key"
                        style="color: #ffffff; font-size: .9em; padding: .2em .5em"
                    >
                        {{ item[field.key] }}
                    </td>
                </tr>
                <template v-if="visibleSensorValues.length > 0">
                    <tr style="background: transparent !important;">
                        <th
                            v-for="sensor in visibleSensorValues"
                            :key="sensor.id"
                            style="color: #BEFF41 !important; font-size: .9em; font-weight: bold; padding: .2em .5em; text-transform: uppercase"
                        >
                            {{ sensor.sensor_display_name || sensor.sensor_name }}
                        </th>
                    </tr>
                    <tr>
                        <td
                            v-for="sensor in visibleSensorValues"
                            :key="sensor.id"
                            style="color: #ffffff; font-size: .9em; padding: .2em .5em"
                        >
                            {{ formatSensorValue(sensor) }}{{ sensor.unit ? ' ' + sensor.unit : '' }}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <span
            class="tip"
            style="color: #00eaff !important;"
        >{{ $t('common.click_to_hide') }}</span>
    </div>
</template>

<script>
export default {
    name: 'MapInfoTable',
    props: {
        fields: {
            type: Array,
            default() {
                return []
            }
        },
        data: {
            type: Array,
            default() {
                return []
            }
        },
        sensorValues: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            title: null
        }
    },
    computed: {
        visibleSensorValues() {
            if (!this.sensorValues) return []
            return this.sensorValues.filter(s => s.show_in_app)
        }
    },
    methods: {
        formatSensorValue(sensor) {
            const val = sensor.calibrated_value != null ? sensor.calibrated_value : sensor.sensor_value
            if (val == null) return '-'
            const num = parseFloat(val)
            return isNaN(num) ? val : num.toFixed(2)
        }
    }
}
</script>
